import React, { useRef } from 'react';
import { useRegisterUiAnchor } from '../../hooks/useRegisterUiAnchor';
import { useShellLayout } from '../../hooks/useShellLayout';
import { UI_ANCHOR_IDS } from '../../services/uiAnchorRegistry';

interface GameViewportProps {
  children: React.ReactNode;
  className?: string;
  boardClassName?: string;
}

const GameViewport: React.FC<GameViewportProps> = ({ children, className, boardClassName }) => {
  const frameRef = useRef<HTMLDivElement>(null);
  const boardRef = useRef<HTMLDivElement>(null);
  const { isMobileShell, viewport } = useShellLayout();

  useRegisterUiAnchor(UI_ANCHOR_IDS.shellFrame, frameRef, { kind: 'shell-frame' }, [
    isMobileShell,
    viewport.width,
    viewport.height,
    viewport.orientation,
  ]);
  useRegisterUiAnchor(UI_ANCHOR_IDS.gameBoard, boardRef, { kind: 'game-board' }, [
    isMobileShell,
    viewport.width,
    viewport.height,
    viewport.orientation,
  ]);

  return (
    <div
      ref={frameRef}
      className={`relative flex min-h-0 w-full flex-1 ${className || ''}`}
      data-shell-mode={isMobileShell ? 'mobile' : 'desktop'}
    >
      <div
        ref={boardRef}
        className={`relative flex min-h-0 w-full flex-1 flex-col ${boardClassName || ''}`}
        data-game-viewport="true"
      >
        {children}
      </div>
    </div>
  );
};

export default GameViewport;
